var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33398 3.33301H12.0007C12.5311 3.33301 13.0398 3.54372 13.4149 3.91879C13.7899 4.29387 14.0007 4.80257 14.0007 5.33301V11.333C14.0007 11.8634 13.7899 12.3721 13.4149 12.7472C13.0398 13.1223 12.5311 13.333 12.0007 13.333H3.33398C2.80355 13.333 2.29484 13.1223 1.91977 12.7472C1.5447 12.3721 1.33398 11.8634 1.33398 11.333V5.33301C1.33398 4.80257 1.5447 4.29387 1.91977 3.91879C2.29484 3.54372 2.80355 3.33301 3.33398 3.33301ZM3.33398 3.99967C3.00065 3.99967 2.70732 4.11301 2.48065 4.31301L7.66732 7.66634L12.854 4.31301C12.6273 4.11301 12.334 3.99967 12.0007 3.99967H3.33398ZM7.66732 8.47301L2.08732 4.85301C2.03398 4.99967 2.00065 5.16634 2.00065 5.33301V11.333C2.00065 11.6866 2.14113 12.0258 2.39118 12.2758C2.64122 12.5259 2.98036 12.6663 3.33398 12.6663H12.0007C12.3543 12.6663 12.6934 12.5259 12.9435 12.2758C13.1935 12.0258 13.334 11.6866 13.334 11.333V5.33301C13.334 5.16634 13.3007 4.99967 13.2473 4.85301L7.66732 8.47301Z",
    fill: "#285430"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a81d69b3f78103a908531a958f8c8979.svg";
export { ForwardRef as ReactComponent };